import {
  IDocumentMediaPreviewData,
  IGroupInfo,
  MESSAGE_CONTENT_TYPE,
} from "@home-health-notify/domain";
import { Box } from "@mui/material";
import React from "react";
import { ReferralAttachmentItem } from "./ReferralAttachmentItem";
import {
  ReferralAttachmentContainer,
  ReferralHeading,
} from "./ReferralAttachment.style";
import { useTranslation } from "hhn-commons";

export const ReferralAttachments = ({
  groupInfo,
}: {
  groupInfo: IGroupInfo;
}) => {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "patientGroup" });

  const mediaList: IDocumentMediaPreviewData[] =
    groupInfo.attachments?.filter(
      (media: IDocumentMediaPreviewData) =>
        media.mediaType === MESSAGE_CONTENT_TYPE.IMAGE,
    ) ?? [];
  return (
    <ReferralAttachmentContainer>
      {groupInfo.attachments && groupInfo.attachments.length > 0 && (
        <Box>
          <ReferralHeading sx={{ marginBottom: "20px" }}>
            {tNs("referralFiles")}
          </ReferralHeading>
          {groupInfo.attachments.map(
            (attachment: IDocumentMediaPreviewData, index: number) => {
              return (
                <ReferralAttachmentItem
                  attachment={attachment}
                  mediaList={mediaList}
                  key={index}
                />
              );
            },
          )}
        </Box>
      )}
    </ReferralAttachmentContainer>
  );
};
